(function ( $ ) {

	$( document )
		.on( 'click', '.menu-toggle button', function ( e ) {
			e.preventDefault();

			$( '#app-nav' ).toggleClass( 'show' );
			$( '.dashboard-area' ).toggleClass( 'push' );

		} )
		.on( 'click', '.category-header', function ( e ) {
			e.preventDefault();

			$( this ).toggleClass( 'collapsed' );
			$( this ).parents( '.category-box' ).find( '.items-container' ).slideToggle();

		} )
		.on( 'click', '.admin-actions a[href^="#"]', function ( e ) {
			e.preventDefault();

			var _cpt_id = $( this ).attr( 'data-object-id' );
			var _cpt_date = $( this ).attr( 'data-object-date' );
			var _date_modal = $( '.dates-modal-wrapper' );

			_date_modal.find( 'input[name="reveal_date"]' ).val( _cpt_date ).prop( 'disabled', false );
			_date_modal.find( 'input[name="cpt_id"]' ).val( _cpt_id );
			_date_modal.find( 'button#save_date' ).prop( 'disabled', false );

			_date_modal.removeClass( 'working' ).fadeIn();

		} )
		.on( 'click', '.date-modal button.close', function ( e ) {
			e.preventDefault();

			$( '.dates-modal-wrapper' ).fadeOut();

		} )
		.on( 'click', '.date-modal button#save_date', function ( e ) {
			e.preventDefault();

			var _date_modal = $( '.dates-modal-wrapper' );
			var _cpt_id = _date_modal.find( 'input[name="cpt_id"]' ).val();
			var _cpt_date = _date_modal.find( 'input[name="reveal_date"]' ).val();
			var _course_id = _date_modal.find( 'input[name="course_id"]' ).val();

			_date_modal.find( 'input[name="reveal_date"]' ).prop( 'disabled', true );
			_date_modal.find( 'button#save_date' ).prop( 'disabled', true );
			_date_modal.addClass( 'working' );

			$.ajax( {
				url: ajaxObj.url,
				method: 'POST',
				dataType: 'json',
				data: {
					action: 'update_object_date',
					course_id: _course_id,
					object_id: _cpt_id,
					object_date: _cpt_date
				},
				success: function ( response ) {

					_date_modal.find( 'input[name="reveal_date"]' ).prop( 'disabled', false );
					_date_modal.find( 'button#save_date' ).prop( 'disabled', false );
					_date_modal.removeClass( 'working' );

					if ( response.success ) {
						_date_modal.fadeOut();
					}

				}
			} );

		} )
		.on( 'click', 'button.full-screen', function ( e ) {
			e.preventDefault();

			var elem = document.getElementById("dashboard-pane");
			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.mozRequestFullScreen) {
				elem.mozRequestFullScreen();
			} else if (elem.webkitRequestFullscreen) {
				elem.webkitRequestFullscreen();
			}

		} );

	// Select2
	$( '#course_lecturer' ).select2( {
		placeholder: {
			id: '-1',
			text: langObj.select_lecturer
		},
		allowClear: true
	} );

	$( '#course_cats, #lesson_cats, #test_cats, #assignment_cats, #link_cats' ).select2( {
		tags: true,
		placeholder: {
			id: '-1',
			text: langObj.select_cats
		}
	} );

})( jQuery );